import React, { useState } from "react";
import SidebarField from "../../../Components/SidebarField";
import { BsThreeDotsVertical } from "react-icons/bs";
import { SlArrowDown, SlArrowUp } from "react-icons/sl";

const DeliverymanDetails = ({ data,setData, modal, setModal }) => {
  const [activeTab, setActiveTab] = useState("details");
  const [activeStatusTab, setActiveStatusTab] = useState(false);

  const statusOptions = ["available", "busy", "offline"];

  const statusColors = {
    available: "bg-green-600 text-white",
    busy: "bg-yellow-500 text-white",
    offline: "bg-red-500 text-white",
  };

  const handleDeliveryChange = () => {
    setActiveStatusTab(!activeStatusTab);
  };

  const handleStatusSelect = (status) => {
    setData((prev) => ({
      ...prev,
      availability: { ...prev.availability, status },
    }));
    setActiveStatusTab(false);
  };

  const tabs = [
    { id: "details", label: "Details" },
    { id: "documents", label: "Documents" },
    { id: "vehicle", label: "Vehicle" },
    { id: "review", label: "Review" },
    { id: "order", label: "Order Information" },
  ];

  if (modal) {
    return (
      <SidebarField
        footer={false}
        handleClose={() => setModal(false)}
        title={`Delivery-Man Details`}
        padding="p-0"
      >
        <div className="bg-transparent w-full">
          <div className="px-4 pt-2 flex space-x-4 border-b">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`pb-2 ${
                  activeTab === tab.id
                    ? "border-b-2 border-[--color--11] text-[--color--11]"
                    : ""
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="mt-4 p-4">
            {activeTab === "details" && (
              <div>
                {/* Basic Information */}
                <section className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">
                  <h2 className="text-lg font-semibold mb-2">
                    Basic Information
                  </h2>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="text-sm font-medium">Name: </label>
                      <p>{`${data?.firstName}  ${data?.lastName}`}</p>
                    </div>
                    <div>
                      <label className="text-sm font-medium">Phone: </label>
                      <p>{data?.phoneNumber || "N/A"}</p>
                    </div>
                    <div>
                      <label className="text-sm font-medium">Email: </label>
                      <p>{data?.email || "N/A"}</p>
                    </div>
                    <div>
                      <label className="text-sm font-medium">Address: </label>
                      <p>{data?.address || "N/A"}</p>
                    </div>
                  </div>
                </section>

                {/* Current Status */}
                <section className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">
                  <div className="relative flex flex-col items-start gap-2">
                    {/* Status Row */}
                    <div
                      className="flex items-center gap-1 absolute right-10 text-blue-500 cursor-pointer"
                      onClick={handleDeliveryChange}
                    >
                      <span>change</span>
                      {activeStatusTab ? (
                        <SlArrowUp size={12} />
                      ) : (
                        <SlArrowDown size={12} />
                      )}
                    </div>

                    {/* Dropdown */}
                    {activeStatusTab && (
                      <div className="absolute top-6 right-10 bg-white border rounded-md shadow p-2 z-10">
                        {statusOptions
                          .filter(
                            (status) => status !== data?.availability?.status
                          )
                          .map((status) => (
                            <div
                              key={status}
                              onClick={() => handleStatusSelect(status)}
                              className="px-3 py-1 hover:bg-gray-100 cursor-pointer capitalize"
                            >
                              {status}
                            </div>
                          ))}
                      </div>
                    )}

                    {/* Label */}
                    <p className="text-lg font-semibold">Current Status</p>

                    {/* Status Badge */}
                    <span
                      className={`px-2 py-1 rounded-md capitalize ${
                        statusColors[data?.availability?.status] ||
                        "bg-gray-200 text-black"
                      }`}
                    >
                      {data?.availability?.status}
                    </span>
                  </div>

                  <p className="pt-2">
                    Last Updated:{" "}
                    {new Date(
                      data?.availability?.lastStatusUpdate
                    ).toLocaleDateString()}
                  </p>
                </section>

                {/* Statistics */}
                <section className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">
                  <h2 className="text-lg font-semibold mb-2">Statistics</h2>
                  <p>Total Deliveries: {data?.statistics?.totalDeliveries}</p>
                  <p>Total Distance: {data?.statistics?.totalDistance} km</p>
                  <p>Completion Rate: {data?.statistics?.completionRate}%</p>
                  <p>
                    Cancelled Deliveries:{" "}
                    {data?.statistics?.cancelledDeliveries}
                  </p>
                </section>

                {/* Bank Details */}
                <section className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">
                  <h2 className="text-lg font-semibold mb-2">Bank Details</h2>
                  <p>Account Holder: {data?.bankDetails?.accountHolder||"Not Available"}</p>
                  <p>Account Number: {data?.bankDetails?.accountNumber||"Not Available"}</p>
                  <p>Bank Name: {data?.bankDetails?.bankName||"Not Available"}</p>
                  <p>IFSC Code: {data?.bankDetails?.ifscCode||"Not Available"}</p>
                </section>
              </div>
            )}

            {activeTab === "documents" && (
              <div>
                <h2 className="text-lg font-semibold mb-2">Documents</h2>
                {Object.entries(data?.documents).map(([key, doc]) => (
                  <div
                    key={key}
                    className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3"
                  >
                    <p>
                      <strong>{key}</strong>: {doc?.number || "Not Provided"}{" "}
                      {doc?.verified ? "(Verified)" : "(Not Verified)"}
                    </p>
                    <p>
                      Expiry: {new Date(doc?.expiryDate).toLocaleDateString()}
                    </p>
                  </div>
                ))}
              </div>
            )}

            {activeTab === "vehicle" && (
              <div>
                <h2 className="text-lg font-semibold mb-2">
                  Registered Vehicles
                </h2>
                <p className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">
                  {data?.vehicleDetails?.model} -{" "}
                  {data?.vehicleDetails?.registrationNumber} (
                  {data?.vehicleDetails?.year})
                </p>
              </div>
            )}

            {activeTab === "review" && (
              <div>
                <h2 className="text-lg font-semibold mb-2">
                  Reviews & Ratings
                </h2>
                <p className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">
                  Average Rating: {data?.reviews?.average} / 5
                </p>
                <p className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">
                  Total Reviews: {data?.reviews?.count}
                </p>
              </div>
            )}

            {activeTab === "order" && (
              <div>
                <h2 className="text-lg font-semibold mb-2">
                  Order Information
                </h2>
                <p className="mb-4 bg-transparent rounded-lg shadow-md w-full border p-3">
                  No orders available.
                </p>
              </div>
            )}
          </div>
        </div>
      </SidebarField>
    );
  }
};

export default DeliverymanDetails;
